/**
 * Generic 2-Segment Inverse Kinematics Chain
 */
window.KinematicChain = class KinematicChain {
  /**
   * @param {p5.Vector} origin - The starting point (e.g., hip or shoulder)
   * @param {number} l1 - Length of the first segment (e.g., thigh)
   * @param {number} l2 - Length of the second segment (e.g., shin)
   */
  constructor(origin, l1, l2) {
    this.origin = origin;
    this.l1 = l1;
    this.l2 = l2;
    this.angles = { a1: 0, a2: 0 };
    this.joints = {
      p1: createVector(), // Mid joint (e.g., knee)
      p2: createVector()  // End joint (e.g., ankle)
    };
  }

  /**
   * Solves the IK for a given target position
   * @param {p5.Vector} target 
   * @param {boolean} reverse - If true, reverses the elbow/knee bend direction
   */
  solve(target, reverse = false) {
    const { x: ox, y: oy } = this.origin;
    const distToTarget = dist(ox, oy, target.x, target.y);
    let tx = target.x;
    let ty = target.y;

    // Constrain target within reach
    const maxReach = this.l1 + this.l2;
    if (distToTarget > maxReach) {
      const angle = atan2(ty - oy, tx - ox);
      tx = ox + cos(angle) * maxReach;
      ty = oy + sin(angle) * maxReach;
    }

    // Law of Cosines with numerical safety
    const d = max(0.01, dist(ox, oy, tx, ty)); // Prevent division by zero
    
    const cosKnee = (this.l1 * this.l1 + this.l2 * this.l2 - d * d) / (2 * this.l1 * this.l2);
    const cosThigh = (d * d + this.l1 * this.l1 - this.l2 * this.l2) / (2 * d * this.l1);

    const angleKnee = acos(constrain(cosKnee, -1, 1));
    const angleThighInTriangle = acos(constrain(cosThigh, -1, 1));
    const angleBase = atan2(ty - oy, tx - ox);

    // Flip the angle calculation if reverse is true
    const angleOffset = reverse ? angleThighInTriangle : -angleThighInTriangle;
    this.angles.a1 = angleBase + angleOffset;
    this.angles.a2 = this.angles.a1 + PI - (reverse ? -angleKnee : angleKnee);

    this.updateJoints();
  }

  updateJoints() {
    this.joints.p1.set(
      this.origin.x + cos(this.angles.a1) * this.l1,
      this.origin.y + sin(this.angles.a1) * this.l1
    );
    this.joints.p2.set(
      this.joints.p1.x + cos(this.angles.a2) * this.l2,
      this.joints.p1.y + sin(this.angles.a2) * this.l2
    );
  }
}

